export default __webpack_public_path__ + "src/assets/icn-investing.fa6782efadf2b25ed7468d8fb9e7433e.svg";